var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9495 15.7509L12.0049 14.5904C11.6662 14.3896 11.3901 13.9066 11.3901 13.5114V10.9395",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.7501C6.79996 22.7501 2.57996 18.5201 2.57996 13.3301C2.57996 11.4601 3.12996 9.65014 4.16996 8.09014C4.39996 7.75014 4.86996 7.65014 5.20996 7.88014C5.54996 8.11014 5.64996 8.58014 5.41996 8.92014C4.54996 10.2201 4.08996 11.7501 4.08996 13.3201C4.08996 17.6901 7.63996 21.2401 12.01 21.2401C16.38 21.2401 19.93 17.6901 19.93 13.3201C19.93 8.95014 16.37 5.40014 12 5.40014C11.08 5.40014 10.18 5.53014 9.32996 5.79014C8.92996 5.91014 8.50996 5.69014 8.38996 5.29014C8.26996 4.89014 8.48996 4.47014 8.88996 4.35014C9.88996 4.05014 10.93 3.89014 12 3.89014C17.2 3.89014 21.42 8.12014 21.42 13.3101C21.42 18.5001 17.2 22.7501 12 22.7501Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86999 6.07012C7.69999 6.07012 7.51999 6.01012 7.37999 5.89012C7.05999 5.61012 7.02999 5.14012 7.29999 4.83012L10.19 1.51012C10.46 1.20012 10.94 1.16012 11.25 1.44012C11.56 1.71012 11.59 2.19012 11.32 2.50012L8.42999 5.81012C8.27999 5.98012 8.06999 6.07012 7.86999 6.07012Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.24 8.53013C11.09 8.53013 10.93 8.48013 10.8 8.39013L7.41995 5.92013C7.08995 5.68013 7.01995 5.21013 7.25995 4.88013C7.49995 4.54013 7.96995 4.47013 8.30995 4.71013L11.68 7.17013C12.01 7.41013 12.09 7.88013 11.84 8.22013C11.7 8.43013 11.47 8.53013 11.24 8.53013Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/history-icon.e4921679d3d634fad76d2af79d0056a6.svg";
export { ForwardRef as ReactComponent };